type ResumeListTypeFilterProps = {
  templatesOnly: boolean
  onChange: (templatesOnly: boolean) => void
  templatesAvailable: boolean
}

const segmentBase =
  'rounded px-3 py-1.5 text-small font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-interactive-focus-ring disabled:cursor-not-allowed disabled:opacity-50'

function segmentClass(active: boolean): string {
  if (active) {
    return `${segmentBase} bg-brand-primary-subtle text-brand-primary shadow-sm`
  }
  return `${segmentBase} text-text-secondary hover:bg-white/80 hover:text-text-primary`
}

/** Segmented list filter — same row as SearchInput (FilterBar gap-3 pattern). */
export default function ResumeListTypeFilter({
  templatesOnly,
  onChange,
  templatesAvailable,
}: ResumeListTypeFilterProps) {
  return (
    <div
      className="inline-flex shrink-0 rounded-md border border-border-strong bg-surface-subtle p-0.5"
      role="group"
      aria-label="Filter resumes by type"
      data-testid="resumes-type-filter"
    >
      <button
        type="button"
        aria-pressed={!templatesOnly}
        onClick={() => onChange(false)}
        className={segmentClass(!templatesOnly)}
      >
        All
      </button>
      <button
        type="button"
        aria-pressed={templatesOnly}
        disabled={!templatesAvailable}
        title={templatesAvailable ? undefined : 'Mark a resume as template first'}
        data-testid="resumes-templates-only-chip"
        onClick={() => onChange(true)}
        className={segmentClass(templatesOnly)}
      >
        Templates
      </button>
    </div>
  )
}
